import { fork } from 'redux-saga/effects';
import modalSaga from './modalSaga';
import toastSaga from './toastSaga';
import apiSaga from './apiSaga';

export default function* rootSaga() {
  yield fork(modalSaga);
  yield fork(toastSaga);
  yield fork(apiSaga);
}
